/*
 * MV endless scroll v3 (15 Oct 2026). Collection and search grids keep loading the next page until the list
 * ends: no page numbers, no Load more. Pagination stays in the HTML (hidden) for Google; bots get plain pages.
 * Back button and reload restore the products and position. CSS: grid section and search.json custom liquid.
 */
(function () {
  'use strict';
  if (window.MVInfiniteScroll) return;

  var ROOT_MARGIN = '0px 0px 1200px 0px';
  var LIST_KEY = 'mvInfiniteScroll.list';
  var POS_KEY = 'mvInfiniteScroll.pos';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var ANCHOR_MS = 4000;
  var BOT_UA = /googlebot|adsbot|google-inspectiontool|bingbot|applebot|yandex|baidu|duckduck|petalbot|semrush|ahrefs|crawler|spider|slurp|lighthouse|pagespeed|gtmetrix/i;

  var observer = null;
  var containerObserver = null;
  var watchedContainer = null;
  var sentinel = null;
  var statusEl = null;
  var loading = false;
  var generation = 0;
  var firstRun = true;
  var state = null;
  var lastAnchor = null;
  var scrollTimer = null;

  function storeJSON(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; }
  }

  function readJSON(key) {
    try { var raw = window.sessionStorage.getItem(key); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }

  function listKey() {
    return window.location.pathname + window.location.search;
  }

  function stripSectionId(url) {
    if (!url || !/[?&]section_id=/.test(url)) return url || '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.delete('section_id');
      return parsed.pathname + parsed.search;
    } catch (e) {
      return url;
    }
  }

  function getContainer() {
    return document.getElementById('ProductGridContainer');
  }

  // Collections: ul#product-grid[data-next-url]. Search: div#product-grid > ul.product-grid.
  function findList(root) {
    var grid = root.querySelector('#product-grid');
    if (!grid) return null;
    var isUl = grid.tagName === 'UL';
    var list = isUl ? grid : grid.querySelector('ul.product-grid');
    if (!list) return null;
    return {
      list: list,
      scope: isUl ? grid.parentNode || grid : grid,
      sectionId: grid.getAttribute('data-id') || '',
      type: isUl ? 'collection' : 'search'
    };
  }

  function liveInfo() {
    var container = getContainer();
    return container ? findList(container) : null;
  }

  function noun(info) {
    return info.type === 'search' ? 'results' : 'products';
  }

  // URL of the page `offset` away, from the pagination links.
  function pageLink(scope, offset) {
    var current = scope.querySelector('.pagination__item--current');
    var target = (current ? parseInt(current.textContent, 10) || 1 : 1) + offset;
    var links = scope.querySelectorAll('.pagination a[href]');
    for (var i = 0; i < links.length; i++) {
      var match = /[?&]page=(\d+)/.exec(links[i].getAttribute('href'));
      if ((match ? parseInt(match[1], 10) : 1) === target) return links[i].getAttribute('href');
    }
    return '';
  }

  function nextUrlOf(info) {
    if (info.list.hasAttribute('data-next-url')) return stripSectionId(info.list.getAttribute('data-next-url'));
    return stripSectionId(pageLink(info.scope, 1));
  }

  function listItems(list) {
    var items = [];
    for (var i = 0; i < list.children.length; i++) {
      if (list.children[i].tagName === 'LI') items.push(list.children[i]);
    }
    return items;
  }

  function itemKey(item) {
    var link = item.querySelector('[id^="CardLink-"]') || item.querySelector('a[href]');
    return link ? link.id || link.getAttribute('href') : null;
  }

  // Moves (not clones) items so custom elements upgrade, as with facets.js. Skips duplicates.
  function appendItems(list, items) {
    var seen = {};
    listItems(list).forEach(function (item) {
      var key = itemKey(item);
      if (key) seen[key] = true;
    });
    var fragment = document.createDocumentFragment();
    var added = 0;
    items.forEach(function (item) {
      var key = itemKey(item);
      if (key && seen[key]) return;
      if (key) seen[key] = true;
      fragment.appendChild(item);
      added++;
    });
    list.appendChild(fragment);
    return added;
  }

  function itemsFromHTML(html) {
    var template = document.createElement('template');
    template.innerHTML = html;
    return Array.prototype.filter.call(template.content.children, function (node) {
      return node.tagName === 'LI';
    });
  }

  function fetchPage(url, sectionId) {
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    return fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var info = findList(new DOMParser().parseFromString(html, 'text/html'));
        // No list: the page no longer exists, so it is the end.
        if (!info) return { url: url, nextUrl: '', items: [], html: '' };
        var items = listItems(info.list);
        var markup = items.map(function (item) { return item.outerHTML; }).join('');
        return { url: url, nextUrl: nextUrlOf(info), items: items, html: markup };
      });
  }

  function announce(message) {
    if (statusEl) statusEl.textContent = message;
  }

  // Search landed on page 2+: link back. Collections render their own.
  function addPreviousLink(info) {
    var previous = pageLink(info.scope, -1);
    if (!previous || info.scope.querySelector('.mv-infinite-scroll__previous')) return;
    var wrapper = document.createElement('p');
    wrapper.className = 'center mv-infinite-scroll__previous';
    wrapper.innerHTML = '<a class="link underlined-link"></a>';
    wrapper.firstChild.setAttribute('href', stripSectionId(previous));
    wrapper.firstChild.textContent = 'Show previous ' + noun(info);
    info.list.parentNode.insertBefore(wrapper, info.list);
  }

  function finish(info) {
    if (observer) observer.disconnect();
    observer = null;
    if (!sentinel || sentinel.classList.contains('is-done')) return;
    sentinel.classList.remove('is-loading');
    sentinel.classList.add('is-done');
    sentinel.removeChild(sentinel.firstChild); // the spinner
    sentinel.insertAdjacentHTML('beforeend',
      '<p class="caption-large light mv-infinite-scroll__end">You’ve reached the end</p>' +
      '<button type="button" class="link underlined-link mv-infinite-scroll__top">Back to top</button>');
    sentinel.querySelector('.mv-infinite-scroll__top').addEventListener('click', function () {
      window.scrollTo(0, 0);
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
    announce('All ' + noun(info) + ' loaded');
  }

  function showRetry(info) {
    if (observer) observer.disconnect();
    if (!sentinel || sentinel.querySelector('.mv-infinite-scroll__retry')) return;
    sentinel.insertAdjacentHTML('beforeend', '<button type="button" class="button button--secondary mv-infinite-scroll__retry">Try again</button>');
    var button = sentinel.querySelector('.mv-infinite-scroll__retry');
    button.addEventListener('click', function () {
      button.parentNode.removeChild(button);
      if (observer && sentinel) observer.observe(sentinel);
      loadNext();
    });
    announce('Could not load more ' + noun(info));
  }

  function remember(page) {
    if (!state) return;
    state.pages.push(page.url);
    state.nextUrl = page.nextUrl;
    state.savedAt = Date.now();
    if (state.html) state.html.push(page.html);
    if (storeJSON(LIST_KEY, state)) return;
    state.html = null; // too big for sessionStorage: keep the page list and re-fetch on return
    if (!storeJSON(LIST_KEY, state)) storeJSON(LIST_KEY, {});
  }

  function loadNext() {
    var info = liveInfo();
    if (loading || !sentinel || !info) return;
    var url = info.list.getAttribute('data-next-url');
    if (!url) return finish(info);
    loading = true;
    sentinel.classList.add('is-loading');
    announce('Loading more ' + noun(info));
    var token = generation;
    fetchPage(url, info.sectionId).then(
      function (page) {
        if (token !== generation) return;
        loading = false;
        sentinel.classList.remove('is-loading');
        var added = appendItems(info.list, page.items);
        info.list.setAttribute('data-next-url', page.nextUrl);
        remember(page);
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'mv_collection_page_loaded', mv_page_url: page.url, mv_items_added: added, mv_list_type: info.type });
        }
        if (!page.nextUrl) return finish(info);
        announce(added + ' more ' + noun(info) + ' loaded');
        // Still near the end (a short page)? Re-observing fires again straight away.
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      },
      function () {
        if (token !== generation) return;
        loading = false;
        sentinel.classList.remove('is-loading');
        showRetry(info);
      }
    );
  }

  function navigationType() {
    try {
      return performance.getEntriesByType('navigation')[0].type;
    } catch (e) {
      return 'navigate';
    }
  }

  function freshState(info) {
    var next = info.list.getAttribute('data-next-url') || '';
    return { v: 3, key: listKey(), first: next, pages: [], html: [], nextUrl: next, savedAt: Date.now() };
  }

  function savePosition() {
    var position = { key: listKey(), y: window.pageYOffset || 0 };
    if (lastAnchor && Date.now() - lastAnchor.at < ANCHOR_MS) {
      position.anchor = lastAnchor.id;
      position.top = lastAnchor.top;
    }
    storeJSON(POS_KEY, position);
  }

  // Remembers the card the shopper tapped, to put it back in the same spot.
  function rememberAnchor(event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    var container = getContainer();
    if (!target || !container || !container.contains(target)) return;
    var item = target.closest('li');
    var link = item ? item.querySelector('[id^="CardLink-"]') : null;
    lastAnchor = link && link.id ? { id: link.id, top: link.getBoundingClientRect().top, at: Date.now() } : null;
    savePosition();
  }

  function restorePosition() {
    var position = readJSON(POS_KEY);
    if (!position || position.key !== listKey()) return;
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    var userMoved = false;
    var apply = function () {
      if (userMoved) return;
      var y = position.y || 0;
      var anchor = position.anchor ? document.getElementById(position.anchor) : null;
      if (anchor) y = anchor.getBoundingClientRect().top + window.pageYOffset - (position.top || 0);
      window.scrollTo(0, Math.max(0, Math.round(y)));
    };
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, function () { userMoved = true; }, { once: true, passive: true });
    });
    apply();
    window.requestAnimationFrame(apply);
    if (document.readyState !== 'complete') window.addEventListener('load', apply, { once: true });
    setTimeout(apply, 400);
  }

  // Puts back the products loaded before the shopper left (promise), or null.
  function restore(info, token) {
    var type = navigationType();
    if (type !== 'back_forward' && type !== 'reload') return null;
    var saved = readJSON(LIST_KEY);
    if (!saved || saved.v !== 3 || saved.key !== listKey() || !saved.pages.length) return null;
    if (Date.now() - saved.savedAt > MAX_AGE_MS || saved.first !== info.list.getAttribute('data-next-url')) return null;
    loading = true;
    var html = saved.html && saved.html.length === saved.pages.length ? saved.html : null;
    var pages = html
      ? Promise.resolve(html.map(itemsFromHTML))
      : Promise.all(saved.pages.map(function (url) {
          return fetchPage(url, info.sectionId).then(function (page) { return page.items; });
        }));
    return pages.then(
      function (pageItems) {
        if (token !== generation) return false;
        loading = false;
        pageItems.forEach(function (items) { appendItems(info.list, items); });
        info.list.setAttribute('data-next-url', saved.nextUrl);
        saved.html = html;
        state = saved;
        restorePosition();
        return true;
      },
      function () {
        if (token !== generation) return false;
        loading = false;
        state = freshState(info);
        storeJSON(LIST_KEY, state);
        return false;
      }
    );
  }

  function teardown() {
    generation++;
    if (observer) observer.disconnect();
    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    observer = sentinel = statusEl = null;
    loading = false;
  }

  function start(info, restored) {
    var next = info.list.getAttribute('data-next-url');
    if (!next && !restored) return; // a single page: nothing to do
    var pagination = info.scope.querySelector('.pagination-wrapper');
    if (pagination) pagination.style.display = 'none';
    sentinel = document.createElement('div');
    sentinel.className = 'mv-infinite-scroll';
    sentinel.innerHTML = '<span class="mv-infinite-scroll__spinner" aria-hidden="true"></span><span class="visually-hidden" role="status"></span>';
    statusEl = sentinel.lastChild;
    info.list.parentNode.insertBefore(sentinel, info.list.nextSibling);
    if (!next) return finish(info);
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) return loadNext();
      }
    }, { rootMargin: ROOT_MARGIN });
    observer.observe(sentinel);
  }

  function watchContainer() {
    var container = getContainer();
    if (container === watchedContainer) return;
    if (containerObserver) containerObserver.disconnect();
    watchedContainer = container;
    if (!container) return;
    // Filters and sorting swap the container's children; appending products does not.
    containerObserver = new MutationObserver(function () { setup(); });
    containerObserver.observe(container, { childList: true });
  }

  function setup() {
    teardown();
    watchContainer();
    var isFirst = firstRun;
    firstRun = false;
    var info = liveInfo();
    if (!info || !('IntersectionObserver' in window) || BOT_UA.test(navigator.userAgent)) return;
    info.list.setAttribute('data-next-url', nextUrlOf(info));
    addPreviousLink(info);
    var token = generation;
    var restoring = isFirst ? restore(info, token) : null;
    if (restoring) {
      restoring.then(function (restored) {
        if (token === generation) start(info, restored);
      });
      return;
    }
    state = freshState(info);
    storeJSON(LIST_KEY, state);
    start(info, false);
  }

  document.addEventListener('click', rememberAnchor, true);
  window.addEventListener('pagehide', function () {
    if (getContainer()) savePosition();
  });
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      if (getContainer()) savePosition();
    }, 300);
  }, { passive: true });

  window.MVInfiniteScroll = { init: setup, version: 3 };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', function () {
    if (getContainer() !== watchedContainer) setup();
  });
})();